module.exports = __webpack_public_path__ + "img/no-records-team-members.6219226b.png";